import React from 'react';
import { Form, Button } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import { connect } from 'react-redux';
import AddEMRCredentail from "./addEditEMR";
import PopupModal from '../modal/popupmodal';
import NewBrightreePhysician from '../physician/newbrightreephysician';
import { Animated } from "react-animated-css";
import CheckPermission from "../../General/CheckPermission";
import RBAC, { ModulesName, UserActions } from "../../General/roleModuleActions";
import Loader from "react-loader-spinner";
import FacilityContact from './facilityContacts';
import moment from "moment-timezone"
import PhysicianModal from '../physician/newPhysician';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { IconButton } from '@material-ui/core';
import * as icons from "@material-ui/icons";

var emrModal, addEMR;

function normalizeFacilityFromProps(facility) {
    const f = { ...facility };
    if (f.cmnSpecialistID == null && f.CMNSpecialistID != null) {
        f.cmnSpecialistID = Number(f.CMNSpecialistID);
    }
    return f;
}

class EditFacility extends React.Component {
    constructor(props) {
        super(props);
        const facilityInitial = normalizeFacilityFromProps(props.Facility);
        this.state = {
            IsLoading: false,
            Is3755Enabled: false,
            openPhysicianModal: false,
            selectOrgOptions: [],
            physicianList: [],
            states: [],
            physicianList: [],
            physician: (facilityInitial.fkPhysicianId > 0 ? { value: facilityInitial.physicianBtId, label: facilityInitial.physicianName } : null),
            physiciansInputValue: '',
            canEdit: props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined ? false : true,
            manager: '',
            vicePresident: '',
            selectOrgChainOptions: [],
            selectFacilityTypeOptions: [],
            selectProductOptions: [],
            selectGroupPurchasingOptions: [],
            selectEhrvendorOption: [],
            selectWarehouseOption: [],
            selectClinicianOptions: [],
            formValidated: false,
            physicianError: false,
            FaciltyID: { ...props.FacilityID },
            Facilty: facilityInitial,
            primaryBillingPerson: '',
            primaryBillingPersonPhone: '',
            primaryBillingPersonEmail: '',
            selectOutsSpecialistOptions: [],
            selectEnteralSpecialistOptions: [],
            cmnSpecialistSelect: null,
            billTypeOuts: '',
            billTypeEnteral: '',
            billTypeOptions: [],
            isEmr: false,
        };
        this.facilityContact = null;
        this.emailError = false;
                  ;
    }

    componentDidMount() {
        this.getAllLookupsValues()
        this.getAllActiveEMR()
        this.getBillTypeOptions()
        this.getAllState()
        if (this.props.Facility.fkClinicianId > 0) {
            this.getRegionalManagerAndVicePresident(this.props.Facility.fkClinicianId);
        }
        this.checkFeatureSwitch();
    }
    async getAllLookupsValues() {

        var res = await Api.getRequest(Api.Uri_GetOrganization);
        const data = res.data.result
        let optionTemplate = data.map((v) => (
            <option key={v.key} value={v.key}>
                {v.value}
            </option>
        ));
        this.setState({ selectOrgOptions: optionTemplate });
        this.setState({ selectOrgChainOptions: optionTemplate });
        var facilityType = await Common.getLookupOptions(Common.LookupsFK.Fk_FacilityTypeID)
        this.setState({ selectFacilityTypeOptions: facilityType })

        var productLine = await Common.getLookupOptions(Common.LookupsFK.Fk_ProductLineID)
        this.setState({ selectProductOptions: productLine })

        // var selectGroupPurchasingOptions = await Common.getLookupOptions(Common.LookupsFK.OrganizationID)
        // this.setState({ selectGroupPurchasingOptions: selectGroupPurchasingOptions })

        var selectEhrvendorOption = await Common.getLookupOptions(Common.LookupsFK.Fk_EHRVendorID)
        this.setState({ selectEhrvendorOption: selectEhrvendorOption })

        var selectWarehouseOption = await Common.getLookupOptions(Common.LookupsFK.Fk_WarehouseID)
        this.setState({ selectWarehouseOption: selectWarehouseOption })
        var clinicain = await Api.getRequestById(Api.Uri_GetUserByRoleID, Common.LookupsFK.Fk_RoleClinicianID);
        const clinicainData = clinicain.data.result
        let clinicainOption = clinicainData.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
        this.setState({ selectClinicianOptions: clinicainOption })
        var outsSpecialist = await Api.getRequestById(Api.Uri_GetUserByRoleID, Common.LookupsFK.Fk_OutsID);
        const outsSpecialistData = outsSpecialist.data.result
        let outsSpecialistOption = outsSpecialistData.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
        this.setState({ selectOutsSpecialistOptions: outsSpecialistOption })
        var enteralSpecialist = await Api.getRequestById(Api.Uri_GetUserByRoleID, Common.LookupsFK.Fk_EnteralID);
        const enteralSpecialistData = enteralSpecialist.data.result
        let enteralSpecialistOption = enteralSpecialistData.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
        this.setState({ selectEnteralSpecialistOptions: enteralSpecialistOption })
        await this.resolveInitialCmnSpecialistSelect();
    }

    async getChainByOrgID(e) {
        Common.updateInputValueInState(this.state.Facilty, e, this, this.state);
        var orgID = this.state.Facilty.fkOrgId;
        const res = await Api.getRequestById(Api.Uri_GetChainByOrgID, orgID);
        const data = res.data.result;
        let optionTemplate = data.map((v) => (
            <option key={v.key} value={v.key}>
                {v.value}
            </option>
        ));
      //  this.setState({ selectOrgChainOptions: optionTemplate });
    }
    getBillTypeOptions = () => {
        Api.getRequestById(Api.Uri_GetLookupValuesByFkId, 1026)
            .then((res) => {
                //console.log("Bill Type API Response:", res);
                if (res.data.statusCode === 200 && res.data.result) {
                    this.setState({ billTypeOptions: res.data.result });
                }
            })
            .catch(err => {
                Common.LogError(err, "AddFacility", "getBillTypeOptions");
            });
    };

    async getChain(orgID) {
        const res = await Api.getRequestById(Api.Uri_GetChainByOrgID, orgID)
        const data = res.data.result
        let optionTemplate = data.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
       // this.setState({ selectOrgChainOptions: optionTemplate })
    }

    onSubmit() {
        let fkChainId = this.state.Facilty.fkChainId;

        // Explicitly set to null if not selected
        if (fkChainId === "N/A" || fkChainId === "") {
            fkChainId = null;
        }
        let fkOrgId = this.state.Facilty.fkOrgId;

        // Explicitly set to null if not selected
        if (fkOrgId === "N/A" || fkOrgId === "") {
            fkOrgId = null;
        }
        const obj = this.state.Facilty;
        obj.fkChainId = fkChainId; 
        obj.fkOrgId = fkOrgId; 
        if (this.form.checkValidity() === false) {
            let _state = this.state;
            _state.formValidated = true;
            this.setState(_state);
        } else {
            const obj = this.state.Facilty;
            var postalCode =   Common.isValidZipCode(obj.address.zip)

            if(!postalCode && obj.address.zip!=""){
               Common.showSuccessAlert("The value is NOT a valid US Zip code", "warning", "Warning!", 3000);
               return false;
            }

            this.setState({ IsLoading: true });

            obj.centerSupplyPersonPhone =
                Common.replaceNullWithString(obj.centerSupplyPersonPhone) != ""
                    ? obj.centerSupplyPersonPhone.replace(/[^0-9]/g, "").substr(0, 10)
                    : null;
            obj.partBrecPersonPhone = Common.replaceNullWithString(obj.partBrecPersonPhone) != ""
                ? obj.partBrecPersonPhone.replace(/[^0-9]/g, "").substr(0, 10)
                : null;
            if (obj.address != null) {
                obj.address.addressId = this.state.Facilty.address.addressId;
                obj.address.phone1 = Common.replaceNullWithString(obj.address.phone1) != ""
                    ? obj.address.phone1.replace(/[^0-9]/g, "").substr(0, 10)
                    : null;

                obj.address.fax = Common.replaceNullWithString(obj.address.fax) != ""
                    ? obj.address.fax.replace(/[^0-9]/g, "").substr(0, 10)
                    : null;
            }
            
            if(this.state.Facilty.email) {
                if(!Common.isValidEmail(this.state.Facilty.email)) {
                    Common.showSuccessAlert("Please enter a valid email address", "warning", "Warning!", 3000);
                    this.setState({ IsLoading: false });
                    return false;
                }
            }

            obj.cmnSpecialistID =
                obj.cmnSpecialistID === "" || obj.cmnSpecialistID == null || Number.isNaN(Number(obj.cmnSpecialistID))
                    ? null
                    : Number(obj.cmnSpecialistID);

            Api.postRequest(Api.Uri_UpdateFacility, obj).then((res) => {

                if (res.data.success) {
                    this.setState({ IsLoading: false });
                    Common.showSuccessAlertAutoClose(
                        "Data Saved Successfully",
                        "success",
                        "Success!",
                        3000
                    );
                    this.props.onSaveAPI();
                } else {
                    Common.showSuccessAlert(res.data.message, "error", "Error!", 3000);
                    this.setState({ IsLoading: false });
                }

            });
        }
        //Common.showSuccessAlert(res.data.message, "error", "Error! " + res.data.statusCode);
    }
    setNpiValue = (e) => {
        var npi = e.target.value;
        if (npi.length < 11) {

            Common.updateInputValueInState(this.state.Facilty, e, this, this.state)


        }

    }

    handleCloseAdd = () => { this.setState({ addBtPhysicianModal: false }) };
    handleShowAddBrightreePhysician = () => {

        this.setState({
            addBtPhysicianComponent: <NewBrightreePhysician close={this.handleCloseAdd}
                selectPhysician={this.selectPhysician} />
        })
        this.setState({ addBtPhysicianModal: true })
    };
    selectPhysician = (obj) => {
        // Common.withOutEventUpdateInputValueInState(this.state.Resident, this, this.state, obj.brightreeId, "fkPrimaryPhysicianId")
        // Common.withOutEventUpdateInputValueInState(this.state.Resident, this, this.state, (obj.lastName+" "+obj.firstName), "primaryPhysicianName")
        var _selectedPhysician = this.state.Facilty;
        _selectedPhysician.physicianViewModel = obj;
        _selectedPhysician.fkPhysicianId = null
        _selectedPhysician.physicianName = Common.replaceNullWithString(obj.lastName) + " " + Common.replaceNullWithString(obj.firstName);
        this.setState({ Facilty: _selectedPhysician })
        Common.showSuccessAlert("Physician selected successfully", "success", "Success!", 3000);

    }
    onProductSpecialistChange = (e) => {
        Common.updateInputValueInState(
            this.state.Facilty,
            e,
            this,
            this.state
        )
        this.setState({ manager: '', vicePresident: '' });

        if (e.target.value > 1) {
            this.getRegionalManagerAndVicePresident(e.target.value);
        }

    }
    getRegionalManagerAndVicePresident = (userID) => {
        Api.getRequestQry(Api.Uri_GetRegionalManagerAndVicePresident, "?userID=" + userID)
            .then((response) => {

                if (response.data.result.length > 0) {
                    for (var i = 0; i < response.data.result.length; i++) {
                        var usr = response.data.result[i];
                        if (usr.managerType == "Manager") {
                            this.setState({ manager: usr.lastName + ' ' + usr.firstName });
                        } else if (usr.managerType == "VicePresident") {
                            this.setState({ vicePresident: usr.lastName + ' ' + usr.firstName });

                        }
                    }

                }

                // this.setState({ selectOrgOptions: optionTemplate });
            })

    }
    getAllActiveEMR() {

        Api.getRequestQry(Api.apiUrls.getAllEMR, "?isActive=" + 1)
            .then((res) => {
                if (res.data.statusCode == 200) {
                    if (res.data.result != null) {
                        if (res.data.result.length > 0) {
                            this.setState({
                                selectGroupPurchasingOptions: res.data.result
                            });
                        }
                    }
                }
            })
            .catch((ex) => { });
    }
    setAllEMR = (users) => {
        return [
            <option key="" value="">Select EMR System</option>,
            ...users.map((usr) => (
                <option key={usr.id} value={usr.id}>
                    {usr.name}
                </option>
            ))
        ];
    };
    showEditEMR = async (id) => {

        var findEmr = this.state.selectGroupPurchasingOptions.find(x => x.id == this.state.Facilty.fkGroupPurchasingOrg)
        // await setEMR(obj);
        if (findEmr != undefined) {
            findEmr.isCredentailUpdate = true;
            this.setState({ emr: findEmr })
            emrModal.showModal();
        }

    };
    onEMRFormSubmit = () => {
        emrModal.hideModal();
        //getHeaderValue() ;
        Common.showSuccessAlertAutoClose("EMR Saved successful", "success", "Success!", 3000);
        this.getAllActiveEMR();
    }
    SyncFacilityGroup = () => {
        Api.getRequest(Api.apiUrls.fetchFacilityGroups)
            .then((res) => {
                if (res.data.statusCode == 200) {
                    Common.showSuccessAlert("Facility Group Fetch Successful", "success", "Success!", 3000);
                }
            })
            .catch((ex) => {
                Common.LogError(ex, "Facility", "NewFacility");

            });
    }
    getAllState() {
        Api.getRequest(Api.Uri_GetState)
            .then((res) => {
                if (res.data.statusCode == 200) {
                    if (res.data.result != null) {
                        if (res.data.result.length > 0) {
                            this.setState({ states: res.data.result });
                        }
                    }
                }
            })
            .catch((ex) => {
                Common.LogError(ex, "Facility", "NewFacility");

            });
    }
    setOptionsUI(options) {
        return options.map((option) => (
            <option key={option.key} value={option.key}>
                {option.value}
            </option>
        ));
    }
    loadPhysicians = async (inputValue) => {
        try {
            if (inputValue.length > 1) {

                var { data } = await Api.getRequestQry(
                    Api.apiUrls.doctorsSearch, `?searchTerm=${inputValue}`
                );
                if (data.success) {
                    let orgList = [];
                    if (data.result.length) {
                        orgList = data.result;
                    }
                    this.setState({ physicianList: orgList })
                    // setOrganizations(orgList)
                    return orgList.map((e) => {
                        return {
                          label: `${e.lastName} ${e.firstName}`,
                          value: (e.brightreeId || e.physicianId)
                        }
                    });
                }
            }
            return [];
        } catch (error) {
            return [];
        }
    };

    setPhysicianInputValue = async (value) => {
        // this.setState({physiciansInputValue:value})
        this.setState({ physiciansInputValue: value });
    }
    onOutsSpecialistChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            [e.target.name]: value
        };
        this.setState({ Facilty: updatedFacilty });
    }

    onEnteralSpecialistChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            [e.target.name]: value
        };
        this.setState({ Facilty: updatedFacilty });
    }

    cmnSpecialistAsyncStyles = {
        control: (base) => ({ ...base, minHeight: "31px", fontSize: "0.875rem" }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
    };

    loadCmnSpecialists = async (inputValue) => {
        try {
            const term = inputValue != null ? String(inputValue).trim() : "";
            const cid = this.state.Facilty.cmnSpecialistID;
            const ensure =
                cid != null && cid !== "" && Number(cid) > 0
                    ? `&ensureUserId=${encodeURIComponent(String(cid))}`
                    : "";
            const q = `?search=${encodeURIComponent(term)}${ensure}`;
            const { data } = await Api.getRequestQry(Api.Uri_GetCmnSpecialistUsers, q);
            const ok =
                data &&
                (data.statusCode === 200 || data.success === true) &&
                Array.isArray(data.result);
            if (!ok) return [];
            return data.result.map((v) => ({
                value: Number(v.key),
                label: Common.replaceNullOrEmptyWithString(v.value, `User #${v.key}`),
            }));
        } catch (ex) {
            Common.LogError(ex, "EditFacility", "loadCmnSpecialists");
            return [];
        }
    };

    setCmnSpecialistSelect = (opt) => {
        this.setState({
            cmnSpecialistSelect: opt,
            Facilty: {
                ...this.state.Facilty,
                cmnSpecialistID: opt ? opt.value : null,
            },
        });
    };

    async resolveInitialCmnSpecialistSelect() {
        const id = this.state.Facilty.cmnSpecialistID;
        if (id == null || id === "") {
            this.setState({ cmnSpecialistSelect: null });
            return;
        }
        const numId = Number(id);
        if (!Number.isFinite(numId) || numId <= 0) {
            this.setState({ cmnSpecialistSelect: null });
            return;
        }
        try {
            const { data } = await Api.getRequestQry(
                Api.Uri_GetCmnSpecialistUsers,
                `?search=&ensureUserId=${encodeURIComponent(String(numId))}`
            );
            const ok =
                data &&
                (data.statusCode === 200 || data.success === true) &&
                Array.isArray(data.result);
            if (!ok) {
                this.setState({ cmnSpecialistSelect: { value: numId, label: `User #${numId}` } });
                return;
            }
            const row = data.result.find((v) => Number(v.key) === numId);
            this.setState({
                cmnSpecialistSelect: row
                    ? {
                          value: numId,
                          label: Common.replaceNullOrEmptyWithString(row.value, `User #${numId}`),
                      }
                    : { value: numId, label: `User #${numId}` },
            });
        } catch (ex) {
            Common.LogError(ex, "EditFacility", "resolveInitialCmnSpecialistSelect");
            this.setState({ cmnSpecialistSelect: { value: numId, label: `User #${numId}` } });
        }
    }

    onBillTypeOutsChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            billTypeOuts: value,
        };
        this.setState({ Facilty: updatedFacilty });
    }
    onBillTypeEnteralChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            billTypeEnteral: value
        };
        this.setState({ Facilty: updatedFacilty });
    }

    setPhysician = (physician) => {
        this.setState({ physician: physician });

        if(physician) {
          const physicianComplete = this.state.physicianList.find(element => (element.brightreeId === physician.value || element.physicianId === physician.value));

          this.setState({ Facilty: { ...this.state.Facilty,
            physicianViewModel: physicianComplete,
            fkPhysicianId: null,
            physicianName: physician.label},
            physician: physician});
        } else {
          this.setState({ Facilty: { ...this.state.Facilty,
            physicianViewModel: null,
            fkPhysicianId: null,
            physicianName: ''}});
        }
    }

    setNewPhysician = (newPhysician) => {
      this.setState({ Facilty: { ...this.state.Facilty,
        physicianViewModel: newPhysician,
        fkPhysicianId: null,
        physicianName: `${newPhysician.lastName} ${newPhysician.firstName}`},
        physician: {value: newPhysician.physicianId, label: `${newPhysician.lastName} ${newPhysician.firstName}`}});
    }

    PrintToPDF() {
        const facilityform = document.querySelector('Form');

        html2canvas(facilityform, { scale: 1, windowWidth: 1440 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({
                orientation: "p", 
                unit: "px", 
                format: [canvas.width + 20, canvas.height + 20], 
            });
            pdf.addImage(imgData, "PNG", 10, 10, canvas.width, canvas.height);
            pdf.save("Facility.pdf");
        });
    }

    checkFeatureSwitch = () => {
        Api.getRequest(Api.URI_FeatureSwitch + "" + 3755).then((response) => {
            this.setState({ Is3755Enabled: response.data.result });
            console.log(response.data.result)
        });
    }

    render() {
        return (
        
            <>
                {this.state.addBtPhysicianModal && <Animated animationIn="fadeInLeft" animationInDuration={1000}>

                    {this.state.addBtPhysicianComponent}

                </Animated>}
                {(this.state.IsLoading == false) ?
                    !this.state.addBtPhysicianModal && <Animated animationIn="fadeInLeft" animationInDuration={1000}>
                <Form 
                    ref={(ref) => { this.form = ref }}
                    validated={this.state.formValidated}
                    onSubmit={e => this.onSubmit(e)}
                 >
                            {this.state.canEdit && document.querySelector("#facilityListTable_wrapper") && <IconButton className="ml-auto d-flex"
                                edge="start"
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => this.PrintToPDF()}
                            >
                                <icons.Print />
                            </IconButton>}

                    {<div>
                        <fieldset  className="p-2 mb-2 bg-light border border-dark rounded">
                            <legend className="text-primary fw-500">Basic Information</legend>
                                    <div className="row">


                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="FacilityName">Facility Name</label>
                                                <input type="text" id="FacilityName"
                                                    name="facilityName"
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                    onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                                    value={this.state.Facilty.facilityName}
                                                    required
                                                    className="form-control form-control-sm" />
                                            </div>
                                        </div>

                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                            <div className="form-group">
                                        <label className="form-label" htmlFor="ThisFacilityBelongsTo">  Ownership-Headquarters </label>
                                        <div className="input-group">
                                            <select className="form-control form-control-sm"
                                                name="fkOrgId"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                value={Common.replaceNullWithString(this.state.Facilty.fkOrgId)}
                                                onChange={e => this.getChainByOrgID(e)}>

                                                <option value="">Select Organization</option>
                                                {this.state.selectOrgOptions}
                                            </select>
                                            <CheckPermission
                                                userRole={RBAC.Role_Gentell_Administrator}
                                                yes={() => (
                                                    <>
                                                        <div className="input-group-append"><button
                                                            type="button"
                                                            onClick={() => { this.SyncFacilityGroup() }}
                                                            className="btn btn-secondary btn-sm">Sync</button>
                                                        </div>
                                                    </>
                                                )}
                                                no={() => null}
                                            />
                                        </div>
                                    </div>
                                </div>
                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="ThisFacilityBelongsTo">Purchasing Group-Chain  </label>
                                            <select className="form-control form-control-sm"
                                                name="fkChainId"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                value={Common.replaceNullWithString(this.state.Facilty.fkChainId)}
                                                onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}>
                                                <option value="">Select Chain</option>
                                                {this.state.selectOrgChainOptions}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="CreatedDate">Start Date</label>
                                            <input type="date"
                                                id="createdDate"
                                                name="createdDate"
                                                min='1900-01-01'
                                                max={Common.getInputStringDateUsingMoment(moment())}
                                                required
                                                defaultValue={this.state.Facilty.createdDate!= null ? Common.getInputStringDate(
                                                        new Date(this.state.Facilty.createdDate)
                                                            ) : ""
                                                }
                                                onChange={(e) =>
                                                    Common.updateInputValueInState(
                                                    this.state.Facilty,
                                                    e,
                                                    this,
                                                    this.state
                                                    )
                                                }
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="FacilityType">Facility Type</label>
                                            <select className="form-control form-control-sm"
                                                name="fkFacilityTypeId"
                                                value={this.state.Facilty.fkFacilityTypeId}
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                required
                                                onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}>
                                                <option value="N/A">Select Facility Type</option>
                                                {this.state.selectFacilityTypeOptions}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="NPINumber">NPI #:</label>
                                            <input type="Number" id="NPINumber"
                                                name="npi"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                value={Common.replaceNullOrEmptyWithString(this.state.Facilty.npi, "")}
                                                onChange={e => this.setNpiValue(e)}
                                                className="form-control form-control-sm" />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="NumberofBeds">Number of Beds</label>
                                            <input type="number" id="NumberofBeds"
                                                name="numberofBeds"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                // required
                                                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                                value={this.state.Facilty.numberofBeds}
                                                className="form-control form-control-sm" />
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="Shipsfromthiswarehouse:">Ships from this warehouse</label>
                                            <select className="form-control form-control-sm"
                                                name="fkWarehouseId"
                                                disabled={
                                                    this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WarehouseManager) == undefined}
                                                value={this.state.Facilty.fkWarehouseId}
                                                onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}>
                                                <option value={null}></option>
                                                {this.state.selectWarehouseOption}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="FacilityType">
                                                Wound and Product Specialist
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                name="fkClinicianId"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                // required
                                                value={this.state.Facilty.fkClinicianId}
                                                onChange={(e) =>
                                                    this.onProductSpecialistChange(e)
                                                }
                                            >
                                                <option>Select Wound Specialist</option>
                                                {this.state.selectClinicianOptions}
                                            </select>
                                        </div>
                                    </div>
                                    
                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="FacilityType">
                                                Regional Manager
                                            </label>
                                            <input
                                                type="text"
                                                disabled
                                                value={this.state.manager}


                                                className="form-control form-control-sm"
                                            />

                                        </div>
                                    </div>
                                    
                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="FacilityType">
                                                OUTs Account Specialist
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                name="fK_OutsID"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                // required
                                                value={this.state.Facilty.fK_OutsID}
                                                onChange={(e) =>
                                                    this.onOutsSpecialistChange(e)
                                                }
                                            >
                                                <option value="">Select OUTs Specialist</option>
                                                {this.state.selectOutsSpecialistOptions}
                                            </select>
                                        </div>
                                    </div>
                                        
                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="FacilityType">
                                                Enteral Account Specialist
                                            </label>
                                            <select
                                                className="form-control form-control-sm"
                                                name="fK_EnteralID"
                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                // required
                                                value={this.state.Facilty.fK_EnteralID}
                                                onChange={(e) =>
                                                    this.onEnteralSpecialistChange(e)
                                                }
                                            >
                                                <option value="">Select Enteral Specialist </option>
                                                {this.state.selectEnteralSpecialistOptions}
                                            </select>
                                        </div>
                                    </div>
                                       
                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="MemberofGroupPurchasingOrg.">EMR System</label>
                                            <div className="input-group">
                                                <select
                                                    className="form-control form-control-sm"
                                                    name="fkGroupPurchasingOrg"
                                                    disabled={
                                                        this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined
                                                }
                                                    
                                                    value={Common.replaceNullWithString(this.state.Facilty.fkGroupPurchasingOrg)}
                                                    onChange={e => {
                                                        const selectedValue = parseInt(e.target.value);

                                                        // Update the state with the new value and handle the websiteAddress change
                                                        this.setState(prevState => {
                                                            let websiteAddress = prevState.Facilty.websiteAddress;
                                                            if (selectedValue !== 2) {
                                                                websiteAddress = "";  // Reset for other values (not 2)
                                                            }

                                                            return {
                                                                Facilty: {
                                                                    ...prevState.Facilty,
                                                                    fkGroupPurchasingOrg: selectedValue,
                                                                    websiteAddress: websiteAddress,
                                                                }
                                                            };
                                                        });
                                                    }}
                                                >
                                                    {this.setAllEMR(this.state.selectGroupPurchasingOptions)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="WebSiteAddress">
                                                Account Name
                                            </label>
                                            <input
                                                name="websiteAddress"
                                                required
                                                value={this.state.Facilty.websiteAddress || ""}
                                                disabled={
                                                    this.state.Facilty.fkGroupPurchasingOrg !== 2 ||
                                                    this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) != undefined ||
                                                    this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) != undefined
                                                }
                                                onChange={(e) =>
                                                    Common.updateInputValueInState(
                                                        this.state.Facilty,
                                                        e,
                                                        this,
                                                        this.state
                                                    )
                                                }
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                    </div>


                                        

                                <CheckPermission
                                    userRole={[
                                        RBAC.Role_Gentell_Administrator,
                                        RBAC.Role_Gentell_RegionalManager,
                                        RBAC.Role_Gentell_WoundCareSpecialist,
                                        RBAC.Role_Gentell_IntakeProcessor,
                                        RBAC.Role_Gentell_SeniorBiller,
                                        RBAC.Role_Gentell_QualityTeam,
                                        RBAC.Role_Gentell_WarehouseManager,
                                        RBAC.Role_Gentell_OutsSpecialist,
                                        RBAC.Role_Gentell_EnteralSpecialist

                                    ]}
                                    yes={() => (
                                        <>

                                        
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="doB">
                                                        User ID
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="emrlogin"
                                                        disabled={
                                                            this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_QualityTeam) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_WarehouseManager) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined}
                                                        className="form-control form-control-sm"
                                                        name="emrlogin"
                                                        defaultValue={
                                                            this.state.Facilty.emrlogin
                                                        }
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="doB">
                                                        Password
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="emrpassword"
                                                        disabled={
                                                            this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_QualityTeam) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_WarehouseManager) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined}
                                                        className="form-control form-control-sm"
                                                        name="emrpassword"
                                                        defaultValue={
                                                            this.state.Facilty.emrpassword
                                                        }
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                            no={() => null}
                                        />

                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex align-items-center">
                                            <label className="checkbox m-0 d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    name="isEmr"
                                                    checked={this.state.Facilty.isEmr}
                                                    onChange={(e) =>
                                                        Common.updateInputValueInState(this.state.Facilty, e, this, this.state)
                                                    }
                                                    className="m-1"
                                                    disabled={
                                                        !this.props.roles.roleList.some((x) =>
                                                            [
                                                                RBAC.Role_Gentell_Administrator,
                                                                RBAC.Role_Gentell_WoundCareSpecialist,
                                                                RBAC.Role_Gentell_RegionalManager,
                                                                RBAC.Role_Gentell_OutsSpecialist,
                                                                RBAC.Role_Gentell_EnteralSpecialist,
                                                            ].includes(x.roleName)
                                                        )
                                                    }
                                                />
                                                <span className="mr-2" />
                                                Use&nbsp;EMR&nbsp;for&nbsp;Billing {/* Use EMR for Billing, displays and prints correctly*/}
                                            </label>
                                        </div>
                            </div>
                        </fieldset>
                        <fieldset disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined} className="p-2 mb-2 bg-light border border-dark rounded">
                            <legend className="text-primary fw-500">Address Information</legend>
                            <div className="row">
                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Memo">
                                            Address Line 1
                                        </label>
                                        <input
                                            className="form-control form-control-sm"

                                            id="address1"
                                            name="addressLine1"
                                            value={Common.replaceNullOrEmptyWithString(this.state.Facilty.address.addressLine1, "")}
                                            onChange={(e) =>
                                                Common.updateInputValueInState(
                                                    this.state.Facilty.address,
                                                    e,
                                                    this,
                                                    this.state
                                                )
                                            }
                                        ></input>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Memo">
                                            Address Line 2
                                        </label>
                                        <input
                                            className="form-control form-control-sm"
                                            id="addressLine2"
                                            name="addressLine2"
                                            value={Common.replaceNullOrEmptyWithString(this.state.Facilty.address.addressLine2, "")}
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}

                                            onChange={(e) =>
                                                Common.updateInputValueInState(
                                                    this.state.Facilty.address,
                                                    e,
                                                    this,
                                                    this.state
                                                )
                                            }
                                        ></input>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="City">City</label>
                                        <input type="text" id="City"
                                            name="city"
                                            onChange={e => Common.updateInputValueInState(this.state.Facilty.address, e, this, this.state)}
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                            value={Common.replaceNullOrEmptyWithString(this.state.Facilty.address.city, "")}
                                            className="form-control form-control-sm" />
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="State">State</label>
                                        <select className="form-control form-control-sm"
                                            name="stateId"
                                            required
                                            onChange={e => Common.updateInputValueInState(this.state.Facilty.address, e, this, this.state)}
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                            value={Common.replaceNullWithString(this.state.Facilty.address.stateId)}
                                        >
                                            <option></option>
                                            {this.setOptionsUI(this.state.states)}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">


                                <div className="col-sm-3 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Phone1">Postal code</label>
                                        
                                        <input
                                            type="number"
                                            id="Zip"
                                            name="zip"
                                            minLength="5" maxLength="9"
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                            value={this.state.Facilty?.address?.zip?.trim()}
                                            onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            onChange={(e) =>
                                                Common.updateInputValueInState(
                                                    this.state.Facilty.address,
                                                    e,
                                                    this,
                                                    this.state
                                                )
                                            }
                                            className="form-control form-control-sm"
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Country">Country</label>
                                        <select className="form-control form-control-sm"
                                            name="countryId"
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                            onChange={e => Common.updateInputValueInState(this.state.Facilty.address, e, this, this.state)}
                                            id="State"
                                            value={Common.replaceNullWithString(this.state.Facilty.address.countryId)}
                                        >
                                            <option value="1">United States</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Phone1">Phone</label>
                                        <input type="phone" id="Phone1"
                                            name="phone1"
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                            onChange={e => Common.updateInputValueInState(this.state.Facilty.address, e, this, this.state)}
                                            value={Common.replaceNullOrEmptyWithString(Common.getFormattedPhoneNum(this.state.Facilty.address.phone1), "")}
                                            className="form-control form-control-sm" />

                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Phone1">Fax</label>
                                        <input type="text" id="Fax"
                                            name="fax"
                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                            onChange={e => Common.updateInputValueInState(this.state.Facilty.address, e, this, this.state)}
                                            value={Common.replaceNullOrEmptyWithString(Common.getFormattedPhoneNum(this.state.Facilty.address.fax), "")}
                                            className="form-control form-control-sm" />
                                    </div>
                                </div>

                            </div>
                        </fieldset>
                       
                        <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                            <legend className="text-primary fw-500">Other Information</legend>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-5 col-xl-4">
                                    <ul className="list-unstyled my-5 border-dark border-md-0 border-right-lg">
                                        <li className="mb-3">
                                            <label className="checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="medicarePartBbyGentell"
                                                    onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                                    checked={this.state.Facilty.medicarePartBbyGentell}
                                                    className="m-1"
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                />
                                                <span className="mr-3" />
                                                Wound&nbsp;Care&nbsp;Part&nbsp;B {/* Wound Care Part B, displays and prints correctly*/} 
                                            </label>
                                        </li>
                                        <li className="mb-3">
                                            <label className="checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="outProgram"
                                                    onChange={e => {
                                                      Common.updateInputValueInState(this.state.Facilty, e, this, this.state); 
                                                    }}
                                                    checked={this.state.Facilty.outProgram}
                                                    className="m-1"
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                        />
                                                <span className="mr-3" />
                                                        OUTs&nbsp;Part&nbsp;B {/* OUTs Part B, displays and prints correctly*/}
                                            </label>
                                        </li>
                                        {this.state.Facilty.outProgram && (
                                          <div className='pl-3 pr-8 mb-3'>
                                            <select className="form-control form-control-sm"
                                              name="fkOutProgramWarehouse"
                                              onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                              id="fkOutProgramWarehouse"
                                              disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                              value={this.state.Facilty.fkOutProgramWarehouse}>
                                              <option value={33}>Bristol</option>
                                              <option value={34}>Chicago</option>
                                            </select>
                                          </div>
                                                )}
                                                {this.state.Facilty.outProgram && (
                                                    <div className='pl-3 pr-8 mb-3'>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="BillTypeOuts"
                                                            value={this.state.Facilty.billTypeOuts} 
                                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                            onChange={this.onBillTypeOutsChange}
                                                        >
                                                            <option value="">Select Bill Type</option>
                                                            {this.state.billTypeOptions.map(opt => (
                                                                <option key={opt.key} value={String(opt.value)}>
                                                                    {opt.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}
                                     <li className="mb-3">
                                            <label className="checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="isEcp"
                                                    checked={this.state.Facilty.isEcp}
                                                    onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="m-1"
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                />
                                                <span className="mr-3" />
                                                        Equal&nbsp;Care&nbsp;Program {/* Equal Care Program, displays and prints correctly*/}
                                            </label>
                                        </li>
                                        <li className="mb-3">
                                            <label className="checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="isThisFacilityFollowingTheCycle"
                                                    onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                                    checked={this.state.Facilty.isThisFacilityFollowingTheCycle}
                                                    className="m-1"
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                />
                                                <span className="mr-3" />
                                                Enteral&nbsp;Program {/* Enteral Program, displays and prints correctly*/}
                                            </label>
                                                </li>
                                                {this.state.Facilty.isThisFacilityFollowingTheCycle && this.state.Is3755Enabled && (
                                                    <div className='pl-3 pr-8 mb-3'>
                                                        <select className="form-control form-control-sm"
                                                            name="fkEnteralProgramWarehouse"
                                                            onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                                            id="fkEnteralProgramWarehouse"
                                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                            value={this.state.Facilty.fkEnteralProgramWarehouse}>
                                                            <option value={34}>Chicago</option>
                                                            <option value={1428}>Lakewood</option> {/* the value may need to be changed in UAT and Prod */}
                                                            
                                                        </select>
                                                    </div>
                                                )}
                                                {this.state.Facilty.isThisFacilityFollowingTheCycle && (
                                                    <div className='pl-3 pr-8 mb-3'>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="BillTypeEnteral"
                                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                            value={this.state.Facilty.billTypeEnteral}
                                                            onChange={this.onBillTypeEnteralChange}
                                                        >
                                                            <option value="">Select Bill Type</option>
                                                            {this.state.billTypeOptions.map(opt => (
                                                                <option key={opt.key} value={opt.value}>
                                                                    {opt.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                )}
                                        <li className="mb-3">
                                            <label className="checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="canAddAssessment"
                                                    checked={this.state.Facilty.canAddAssessment}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                    onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="m-1"
                                                />
                                                <span className="mr-3" />
                                                Facility&nbsp;use&nbsp;of&nbsp;Fastcare {/* Facility use of Fastcare, displays and prints correctly*/}
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                        <div className="col-sm-12 col-md-12 col-lg-7 col-xl-8">
                                            <div className="row">
                                                <div className="col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                                    <div className="form-group">
                                                        <label
                                                            className="form-label"
                                                            htmlFor="primaryBillingPerson"
                                                        >
                                                            Primary Billing Person
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="primaryBillingPerson"
                                                            name="primaryBillingPerson"
                                                            value={this.state.Facilty.primaryBillingPerson}
                                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined}
                                                            onChange={(e) =>
                                                                Common.updateInputValueInState(
                                                                    this.state.Facilty,
                                                                    e,
                                                                    this,
                                                                    this.state
                                                                )
                                                            }
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                    <div className="form-group">
                                                        <label className="form-label" htmlFor="primaryBillingPersonPhone1">
                                                            Primary Billing Person Phone #
                                                        </label>
                                                        <input
                                                            type="phone"
                                                            id="primaryBillingPersonPhone"
                                                            name="primaryBillingPersonPhone"
                                                            value={Common.replaceNullOrEmptyWithString(Common.getFormattedPhoneNum(this.state.Facilty.primaryBillingPersonPhone), "")}
                                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined} onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>


                                                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                    <div className="form-group">
                                                        <label className="form-label" htmlFor="primaryBillingPersonEmail">
                                                            Primary Billing Person Email
                                                        </label>
                                                        <input
                                                            type="phone"
                                                            id="primaryBillingPersonEmail"
                                                            name="primaryBillingPersonEmail"
                                                            value={Common.replaceNullOrEmptyWithString(this.state.Facilty.primaryBillingPersonEmail, "")}
                                                            disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined} onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                            className="form-control form-control-sm"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                    <div className="row">
                                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group">
                                                <label
                                                    className="form-label"
                                                    htmlFor="PartBReceivingPerson"
                                                >
                                                    Part B Receiving Person
                                                </label>
                                                <input
                                                    type="text"
                                                    id="PartBReceivingPerson"
                                                    name="partBrecPerson"
                                                    value={this.state.Facilty.partBrecPerson}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined}
                                                    onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="Phone1">
                                                    Receiving Person Phone #
                                                </label>
                                                <input
                                                    type="phone"
                                                    id="partBrecPersonPhone"
                                                    name="partBrecPersonPhone"
                                                    value={Common.replaceNullOrEmptyWithString(Common.getFormattedPhoneNum(this.state.Facilty.partBrecPersonPhone), "")}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined    } onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>


                                        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="Phone1">
                                                    Receiving Person Email
                                                </label>
                                                <input
                                                    type="phone"
                                                    id="partBrecPersonEmail"
                                                    name="partBrecPersonEmail"
                                                    value={Common.replaceNullOrEmptyWithString(this.state.Facilty.partBrecPersonEmail, "")}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                            } onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group">
                                                <label
                                                    className="form-label"
                                                    htmlFor="Central Supply Person"
                                                >
                                                    Central Supply Person
                                                </label>
                                                <input
                                                    type="text"
                                                    id="Stree2:"
                                                    name="centralSupplyPerson"
                                                    value={this.state.Facilty.centralSupplyPerson}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                            } onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="Phone1">
                                                    Central Supply Person Phone #
                                                </label>
                                                <input
                                                    type="phone"
                                                    id="centerSupplyPersonPhone"
                                                    name="centerSupplyPersonPhone"
                                                    value={Common.replaceNullOrEmptyWithString(Common.getFormattedPhoneNum(this.state.Facilty.centerSupplyPersonPhone), "")}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                            } onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="Phone1">
                                                    Central Supply Person Email
                                                </label>
                                                <input
                                                    type="text"
                                                    id="centerSupplyPersonEmail"
                                                    name="centerSupplyPersonEmail"
                                                    value={Common.replaceNullOrEmptyWithString(this.state.Facilty.centerSupplyPersonEmail, "")}
                                                    disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                            } onChange={(e) =>
                                                        Common.updateInputValueInState(
                                                            this.state.Facilty,
                                                            e,
                                                            this,
                                                            this.state
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="cmnSpecialistID">
                                                    CMN Specialist
                                                </label>
                                                <AsyncSelect
                                                    inputId="cmnSpecialistID"
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={this.loadCmnSpecialists}
                                                    value={this.state.cmnSpecialistSelect}
                                                    onChange={this.setCmnSpecialistSelect}
                                                    isClearable
                                                    filterOption={() => true}
                                                    isDisabled={
                                                        this.props.roles.roleList.find(
                                                            (x) => x.roleName == RBAC.Role_Gentell_Administrator
                                                        ) === undefined
                                                    }
                                                    placeholder="Search CMN specialist…"
                                                    noOptionsMessage={() => "No matches — try another name or email"}
                                                    loadingMessage={() => "Loading…"}
                                                    styles={this.cmnSpecialistAsyncStyles}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-4">
                                            <div className="form-group">
                                                <label className="form-label" htmlFor="gender">
                                                    Medical Director or Physician signing Facility CMNs
                                                </label>
                                                <AsyncSelect
                                                    name='organizationID'
                                                    noOptionsMessage={() => 
                                                      this.state.physiciansInputValue.length>=3 ?
                                                      <Button  variant="success" className="mr-5 px-10" size="sm"
                                                      disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                          && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                          && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                                } onClick={() => this.setState({ openPhysicianModal: true })}>New</Button> : ''}
                                                    inputValue={this.state.physiciansInputValue}
                                                    isdisabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                        && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined}
                                                    onInputChange={this.setPhysicianInputValue}
                                                    value={this.state.physician}
                                                    onChange={(obj) => {
                                                        this.setPhysician(obj);
                                                    }}
                                                    loadOptions={this.loadPhysicians}
                                                    isClearable
                                                />
                                            </div>
                                        </div>
                                        <div className="col-4">
                                          <div className="form-group mt-7">
                                            <label className="form-label" htmlFor="email">Email</label>
                                            <input 
                                              type="text"
                                              name="email"
                                              id="email"
                                              className={this.state.emailError ? "form-control form-control-sm is-invalid": "form-control form-control-sm"}
                                              value={this.state.Facilty.email}
                                              disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                  && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                  && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                            } onChange={(e) =>
                                                { Common.updateInputValueInState(this.state.Facilty, e, this, this.state); 
                                                  if(e.target.value && !Common.isValidEmail(e.target.value)) {
                                                    this.setState({emailError: true})
                                                  } else {
                                                    this.setState({emailError: false})
                                                  }
                                                }
                                              }  
                                            />
                                          </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group mt-15">
                                                <label className="checkbox">
                                                    <input
                                                        type="checkbox"
                                                        name="singingForAllCmns"
                                                        checked={this.state.Facilty.singingForAllCmns}
                                                        disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                            && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                            && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                                } onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="m-1"
                                                    />
                                                    <span className="mr-3" />
                                                    Signing&nbsp;For&nbsp;All&nbsp;CMNs {/* Signing For All CMNs, displays and prints correctly*/}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label className="form-label" htmlFor="Memo">Memo</label>
                                        <textarea className="form-control"
                                            value={this.state.Facilty.memo}
                                            disabled={
                                                this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                             && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined 
                                             && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                             && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                        && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined                                                    } name="memo"
                                            onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                            id="Memo" rows="3"
                                            // disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}     
                                            ></textarea>
                                    </div>
                                </div>
                            </div>
                        </fieldset>


                    </div>
                    }


                </Form>

                {this.state.openPhysicianModal && (
                  <PhysicianModal
                    onSaveAPI={this.setNewPhysician}
                    open={this.state.openPhysicianModal}
                    toggleModal={()=>this.setState({openPhysicianModal:false})}
                  />
                )}

                <PopupModal
                    size="lg"
                    title="Add EMR"
                    module={ModulesName.Module_Setup}
                    action={UserActions.Create}
                    buttonPress={() => addEMR.onSubmit()}
                    ref={(ref) => {
                        emrModal = ref;
                    }}
                >
                    {" "}
                    <AddEMRCredentail
                        ref={(ref) => {
                            addEMR = ref;
                        }}
                        onSaveAPI={() => this.onEMRFormSubmit()}
                        emr={this.state.emr}
                    />{" "}
                </PopupModal>
                </Animated>
                :
            <div className="d-flex justify-content-center">
              <Loader
                type="Puff"
                color="#00BFFF"
                height={50}
                width={50}
              />
            </div>
          }
            </>
        );
    }
}
const mapStateToProps = (state) => {
    const roles = state.auth.user.roles;
    return { roles }
};
//   export default connect(mapStateToProps)(ProductSelection)
export default
    connect(mapStateToProps,
        {}
        , null, { forwardRef: true })(EditFacility);
